document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.main-recipe-tabs [data-filter]')
  const items = document.querySelectorAll('.main-recipe-list__item')
  const linkBtn = document.querySelector('.main-recipe__head-btn')
  const baseLink = linkBtn.getAttribute('href')
  const el = document.querySelector('.main-recipe .swiper-container')

  if (!tabs.length || !items.length || !el) return

  const swiper = new Swiper(el, {
    loop: false,
    speed: 600,
    slidesPerView: 1.4,
    spaceBetween: 8,
    centeredSlides: false,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.main-recipe__controller-next',
      prevEl: '.main-recipe__controller-prev',
    },
    a11y: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
    observer: true,
    observeParents: true,
  })

  // 첫 번째 탭 활성화
  tabs[0].classList.add('s-active')
  const firstFilter = tabs[0].getAttribute('data-filter')
  filterItems(firstFilter)
  linkBtn.setAttribute("href", `${baseLink}?tag=${firstFilter.toString()}`)

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('s-active'))
      tab.classList.add('s-active')

      const filterValue = tab.getAttribute('data-filter')
      filterItems(filterValue)
      linkBtn.setAttribute("href", `${baseLink}?tag=${filterValue.toString()}`)

      tab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    })
  })

  function normalize(str) {
    return str.replace(/\s+/g, ' ').trim().toLowerCase()
  }

  function filterItems(filter) {
    const normalizedFilter = normalize(filter)

    items.forEach((item) => {
      const tags = item.dataset.tags
        ? item.dataset.tags.split(',').map(tag => normalize(tag))
        : []

      item.style.display = tags.includes(normalizedFilter) ? '' : 'none'
    })

    // Swiper 갱신
    swiper.update()
    swiper.slideTo(0, 0)
  }
})
